import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import axiosInstance from "src/store/features/auth/axiosCSRF";
export interface iLibraryRoundUpdateState {
    group_name: string;
    library_name: string;
    round_num: number;
    isLoading: boolean;
    message: string | null;
    response: any[];
}


const initialState: iLibraryRoundUpdateState = {
    group_name: "",
    library_name: "",
    round_num: null,
    isLoading: false,
    message: "",
    response: [],
};

// Rename Library API 호출
export const libraryRoundUpdateAPI = createAsyncThunk(
    "ROUND_UPDATE_LIBRARY",
    async (params: { group_name: string; library_name: string; round_num: number }, { rejectWithValue }) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            const pathParam = '/library/created-round-update/';
            const response = await axiosInstance.post(`${djangoEndpoint}${pathParam}`, {
                group_name: params.group_name,
                library_name: params.library_name,
                round_num: params.round_num,
            }, {
                withCredentials: true,
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// Rename Library Slice
export const libraryRoundUpdateSlice = createSlice({
    name: "libraryRoundUpdate",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(libraryRoundUpdateAPI.pending, (state) => {
                state.isLoading = true;
                state.message = "";
            })
            .addCase(libraryRoundUpdateAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.response = action.payload;
            })
            .addCase(libraryRoundUpdateAPI.rejected, (state, action) => {
                state.isLoading = false;
                state.message = action.payload as string;
            });
    },
});

export default libraryRoundUpdateSlice.reducer;